import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {patchJSONPromise, postJSONPromise} from 'util/Net';

import {LibraryParameterDefinitionDataType} from '../ParameterLibraryTypes';

export function libraryParameterDefinitionsListingURL(): string {
  return '/library-parameter-definitions/listing';
}

export interface CreateLibraryParameterDefinitionParams {
  name: string;
  unitTypeId: string | null;
  schemaFieldSelectorId: string | null;
  description: string;
  dataType: LibraryParameterDefinitionDataType;
}

export interface CreateLibraryParameterDefinitionResponse {
  createdIds: Array<string>;
}

export function createLibraryParameterDefinition(
  parameterDefinition: CreateLibraryParameterDefinitionParams
): Promise<CreateLibraryParameterDefinitionResponse> {
  const creates = [parameterDefinition];
  return postJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.LIBRARY_PARAMETER_DEFINITION),
    data: {creates},
  });
}

export interface UpdateLibraryParameterDefinitionParams {
  id: string;
  name?: string;
  description?: string;
}

export interface UpdateLibraryParameterDefinitionResponse {
  updatedIds: Array<string>;
}

export function updateLibraryParameterDefinition(
  parameterDefinition: UpdateLibraryParameterDefinitionParams
): Promise<UpdateLibraryParameterDefinitionResponse> {
  const updates = [parameterDefinition];
  return patchJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.LIBRARY_PARAMETER_DEFINITION),
    data: {updates},
  });
}
